import { combineReducers } from "redux"
import { reducer as busTable } from './busTable/busTableRedux'
import { reducer as busForm } from './busForm/busFormRedux'
export const reducer = combineReducers({
    busTable,
    busForm
})